import React from 'react'
import BlogPost from './BlogPost'

export default function Family() {
  return (
    <BlogPost
      translationKey="family"
      seoTitle="Family | Hyunjin Jae"
      seoDescription="Reflections on family and what truly matters."
      seoKeywords="family, reflection, life"
      seoTags={['family', 'reflection']}
    />
  )
}
